import { Steps } from 'antd'
import EmptyCircle from 'components/icons/EmptyCircle'
import StepsCompleted from 'components/icons/StepsCompleted'
import StepsIcon from 'components/icons/StepsIcon'
import React from 'react'
import styled from 'styled-components'
import { COLORS } from 'theme'
import {
  autoJDFillStepNum,
  ctcOrStipendStepNum,
  eligibilityCriteriaStepNum,
  jobDetailsStepNum,
  previewStepNum,
} from '../../modules/JobRoles/NewJobRole/RolesForm/Partials/EligibiltyCriteria/CommonFunctions'

const { Step } = Steps

const Div = styled.div`
  .ant-steps-item-finish
    > .ant-steps-item-container
    > .ant-steps-item-tail::after {
  }
`
const Title = styled.h2`
  font-weight: 500;
  font-size: 15px;
  line-height: 21px;
  color: ${props => props.textcolor};
  font-weight: 600;
`
const StyledStep = styled(Step)`
  .ant-steps-item-title {
    width: 100%;
    padding-bottom: 5px;
    border-bottom: 1px solid ${COLORS.GREY_T_90};
  }
`
const StyledSteps = styled(Steps)``
export const RoundDiv = styled.p`
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 15px;
  color: #999fac;
`

const AntdSteps = ({
  steps,
  direction = 'vertical',
  size = 'small',
  current = '1',
  progressCheck = false,
  currentState,
  onTabChange,
  roleLoading,
  setRoleLoading,
  checkAllCompleted = false,
  step,
  stepStatus,
  id,
  confirmLoading,
  ...props
}) => {
  const Icon = step => {
    if (stepStatus?.jd && step?.activeKey == autoJDFillStepNum) {
      return <StepsCompleted />
    } else if (stepStatus?.job && step?.activeKey == jobDetailsStepNum) {
      return <StepsCompleted />
    } else if (stepStatus?.ctc && step?.activeKey == ctcOrStipendStepNum) {
      return <StepsCompleted />
    } else if (
      stepStatus?.qualification &&
      step?.activeKey == eligibilityCriteriaStepNum
    ) {
      return <StepsCompleted />
    } else if (
      checkAllCompleted &&
      stepStatus?.job &&
      stepStatus?.ctc &&
      stepStatus?.qualification &&
      step?.activeKey >= previewStepNum
    ) {
      return <StepsCompleted />
    } else if (checkAllCompleted) {
      return <StepsIcon />
    } else if (current >= step?.activeKey) {
      return <StepsIcon />
    } else if (
      stepStatus?.qualification &&
      current < eligibilityCriteriaStepNum &&
      step?.activeKey < eligibilityCriteriaStepNum
    ) {
      return <StepsIcon />
    } else {
      return <EmptyCircle />
    }
  }
  const checkPointerCondition = key => {
    if (key >= previewStepNum) {
      return !stepStatus?.job && !checkAllCompleted
    } else {
      return confirmLoading
    }
  }
  return (
    <Div>
      <StyledSteps
        direction={direction}
        size={size}
        current={current}
        {...props}
      >
        {steps?.map((step, index) => {
          return (
            <StyledStep
              style={{
                pointerEvents: checkPointerCondition(step?.activeKey)
                  ? 'none'
                  : '',
                cursor: checkPointerCondition(step?.activeKey)
                  ? 'unset'
                  : 'pointer',
              }}
              disabled={
                (step?.activeKey >= previewStepNum &&
                  (!stepStatus?.ctc ||
                    !stepStatus?.job ||
                    !stepStatus?.qualification)) ||
                confirmLoading
              }
              key={index + 'steps'}
              icon={Icon(step)}
              title={
                <Title
                  textcolor={
                    current == step?.key - 1
                      ? COLORS.GREY_T_30
                      : COLORS.GREY_T_60
                  }
                >
                  {step?.title}
                </Title>
              }
              description={
                <RoundDiv
                  textcolor={
                    step?.activeKey == current
                      ? COLORS.GREY_T_30
                      : COLORS.GREY_T_60
                  }
                >
                  {step?.description}
                </RoundDiv>
              }
              onClick={() => {
                if (step?.activeKey !== current) {
                  onTabChange(step?.activeKey)
                }
              }}
            />
          )
        })}
      </StyledSteps>
    </Div>
  )
}

export default AntdSteps
